import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { Col, FormGroup, Modal, Row } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { MultiSelect } from 'react-multi-select-component';
import { useManualState } from './Provider';
import { createOptions, customStyles } from '../../Components/helper';
import UploadFileAndDocument from '../../Components/UploadFileAndDocument/UploadFileAndDocument';
import CustomDatePicker from '../../Components/Utility/DatePicker/DatePicker';
import * as action from './store/Document.action';
import * as systemMasterAction from '../SystemMasters/Store/SystemMasters.action';
import { CloseIcon, TickIcon } from '../../bombiix-icon';

function UploadDocument({ onOpen, toggle }) {
  const { state, setState } = useManualState(); // Assuming this manages your component state
  const { t } = useTranslation('common');
  const childRef = useRef(null);
  const dispatch = useDispatch();
  const reducer = useSelector((reducerstate) => reducerstate);
  const [supplierOptions, setSupplierOptions] = useState([]);
  const [subBrandOptions, setSubBrandOptions] = useState([]);
  const [folderId, setFolderId] = useState(null);

  useEffect(() => {
    const documentData = JSON.parse(localStorage.getItem('manualDoumentFolder')) || {};
    if (documentData?._id) {
      setFolderId(documentData._id);
    }
  }, []);

  const {
    SystemMastersDetails: { brandList, documentTypeList, subBrandAccess, multiSubBrandList },
    BomLibraryDetails: { ReferenceSupplier },
    DocumentReducer: { fileDataById },
  } = reducer;

  const [localState, setLocalStateData] = useState({
    documentTitle: '',
    expiryDate: null,
    documentType: null,
    selectedBrand: null,
    selectedSupplier: null,
    selectedSubBrand: null,
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (fileDataById) {
      setLocalStateData((prev) => ({
        ...prev,
        documentTitle: fileDataById?.documentTitle,
        expiryDate: fileDataById?.expiredAt || null,
        documentType: documentTypeList?.filter((re) => re?._id === fileDataById?.documentType)?.[0] || null,
        selectedBrand: brandList?.filter((re) => re?._id === fileDataById?.brand)?.[0] || null,
        selectedSupplier: supplierOptions?.filter((option) => fileDataById?.suppliers?.includes(option._id)) || [],
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileDataById, supplierOptions, brandList, documentTypeList]);

  useEffect(() => {
    if (subBrandOptions && fileDataById?.brand) {
      console.log(fileDataById?.subBrand, 'fileDataById?.subBrand');
      setLocalStateData((prev) => ({
        ...prev,
        selectedSubBrand: subBrandOptions?.filter((option) => option._id === fileDataById?.subBrand) || null,
      }));
    }
  }, [subBrandOptions, fileDataById]);

  const validateForm = () => {
    const newErrors = {};

    if (!localState?.documentTitle?.trim()) {
      newErrors.documentTitle = 'Document Title is required.';
    }
    if (!localState?.documentType) {
      newErrors.documentType = 'Document Type is required.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  useEffect(() => {
    if (ReferenceSupplier) {
      setSupplierOptions(createOptions(ReferenceSupplier, 'name', '_id'));
    }
  }, [ReferenceSupplier]);

  // Fetch sub-brand access on component mount
  useEffect(() => {
    dispatch(systemMasterAction.getSubBrandAccess());
  }, [dispatch]);

  useEffect(() => {
    if (onOpen && !state?.isEditFile && !localState?.selectedBrand && subBrandAccess) {
      setSubBrandOptions([]);
    }
  }, [onOpen, state?.isEditFile, localState?.selectedBrand, subBrandAccess]);

  useEffect(() => {
    if (localState?.selectedBrand?._id && subBrandAccess) {
      dispatch(systemMasterAction.getMultiSubBrandDetails({ brandId: [localState.selectedBrand._id] }));
    } else {
      setSubBrandOptions([]);
    }
  }, [dispatch, localState?.selectedBrand?._id, subBrandAccess]);

  useEffect(() => {
    if (multiSubBrandList?.length && localState?.selectedBrand?._id && subBrandAccess) {
      setSubBrandOptions(createOptions(multiSubBrandList, 'name', '_id'));
    } else {
      setSubBrandOptions([]);
    }
  }, [multiSubBrandList, localState?.selectedBrand?._id, subBrandAccess]);

  const handleSelect = (selectedOption, field) => {
    setLocalStateData((prev) => {
      const updatedState = {
        ...prev,
        [field]: selectedOption,
      };

      if (field === 'selectedBrand' && subBrandAccess) {
        // Clear sub-brand when brand changes or is deselected (only if sub-brand access is enabled)
        updatedState.selectedSubBrand = null;
      }

      return updatedState;
    });
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    const fecthSelectedSupplier = localState?.selectedSupplier?.map((res) => res._id);
    let res = null;
    if (state?.isEditFile && fileDataById?._id) {
      const obj = {
        documentTitle: localState?.documentTitle,
        documentType: localState?.documentType?._id,
        expiredAt: localState?.expiryDate || null,
        brand: localState?.selectedBrand?._id || null,
        suppliers: fecthSelectedSupplier || [],
        _id: fileDataById?._id,
        type: 'file',
      };

      // Only include sub-brand if access is enabled
      if (subBrandAccess) {
        obj.subBrand = localState?.selectedSubBrand?._id || [];
      }
      setState((prev) => ({
        ...prev,
        loading: true,
      }));

      res = await dispatch(action.updateManualDocument(obj, t));
      if (res) {
        setState((prev) => ({
          ...prev,
          loading: false,
        }));
      }
    } else {
      const uploadedDoc = await childRef.current.selectedDocument();
      if (uploadedDoc?.document) {
        const formData = new FormData();
        formData.append('fileObj', uploadedDoc?.document);
        formData.append('documentTitle', localState?.documentTitle);
        formData.append('documentType', localState?.documentType?._id);
        formData.append('expiredAt', localState?.expiryDate || null);
        formData.append('brand', localState?.selectedBrand?._id || null);
        formData.append('suppliers', fecthSelectedSupplier || []);
        formData.append('folderId', folderId || null);

        // Only include sub-brand if access is enabled
        if (subBrandAccess) {
          formData.append('subBrand', localState?.selectedSubBrand?._id || []);
        }

        formData.append('type', 'file');
        setState((prev) => ({
          ...prev,
          loading: true,
        }));
        if (state?.isFromRenew && fileDataById?._id) {
          res = await dispatch(action.renewManualDocument({ formData, type: 'file', folderId: folderId || null, _id: fileDataById?._id }, t));
        } else {
          res = await dispatch(action.saveManualDocument({ formData, type: 'file', folderId: folderId || null }, t));
        }
        if (res) {
          setState((prev) => ({
            ...prev,
            loading: false,
          }));
        }
      }
    }

    if (res?.code === 200) {
      setLocalStateData((prev) => ({
        ...prev,
        documentTitle: '',
        expiryDate: null,
        documentType: null,
        selectedBrand: null,
        selectedSupplier: [],
        selectedSubBrand: subBrandAccess ? null : prev.selectedSubBrand,
      }));
      if (subBrandAccess) {
        setSubBrandOptions([]);
      }
      toggle();
    }
  };

  const getModalTitle = () => {
    if (state?.isFromRenew) {
      return 'Renew Document';
    }
    if (state?.isEditFile) {
      return 'Edit Document';
    }
    return 'Upload Document';
  };

  const handleClose = () => {
    setLocalStateData((prev) => ({
      ...prev,
      documentTitle: '',
      expiryDate: null,
      documentType: null,
      selectedBrand: null,
      selectedSupplier: [],
      selectedSubBrand: subBrandAccess ? null : prev.selectedSubBrand,
    }));
    if (subBrandAccess) {
      setSubBrandOptions([]);
    }
    toggle();
  };

  return (
    <Modal
      show={onOpen}
      size="md"
      backdrop="static"
      aria-labelledby="contained-modal-title-vcenter"
      className="common-custom-modal modal-large"
      onHide={handleClose}
    >
      <Modal.Header>
        <Modal.Title className="f-24 text-bold" id="contained-modal-title-vcenter">
          {getModalTitle()}
        </Modal.Title>
        <CloseIcon size={28} onClick={handleClose} className="cursor-pointer" />
      </Modal.Header>

      <Modal.Body>
        <>
          {!state?.isEditFile && (
            <div>
              <UploadFileAndDocument
                showTitleField={false}
                acceptedFileExtenstion=".jpeg,.png,xls,.xlsx,.pdf,.psd,.doc,.txt,.rar,.png,.jpeg,.jpg,.bmp,.tif,.raw,.etc,.gif,.ppt,.svg,.exp,.pptx,.ods"
                ref={childRef}
              />
            </div>
          )}

          <Row className="mt-3">
            <Col lg="8">
              <FormGroup>
                <FormGroup>
                  <div className="input-group">
                    <input
                      type="text"
                      name="documentTitle"
                      maxLength={100}
                      placeholder={t('MANUAL_DOCUMENTS.DOCUMENT_TITLE')}
                      className={`form-control text-bordered ${errors.documentTitle ? 'is-invalid' : ''}`}
                      value={localState.documentTitle}
                      onChange={(e) => setLocalStateData({ ...localState, documentTitle: e.target.value })}
                    />
                    {errors.documentTitle && <div className="invalid-feedback">{errors.documentTitle}</div>}
                  </div>
                  <div className="document-character-counter">{localState.documentTitle?.length || 0}/100</div>
                </FormGroup>
              </FormGroup>
            </Col>
            <Col lg="4">
              <FormGroup className="custom-date-doc mb-0">
                <div className="">
                  <CustomDatePicker
                    dateFormat="dd/MM/yyyy"
                    name="expiryDate"
                    classes="form-control"
                    placeholder={t('ADD_EDIT_SUPLIER.EXPIRY_DATE')}
                    selected={localState.expiryDate}
                    valueProp={localState.expiryDate || null}
                    onChange={(date) => setLocalStateData({ ...localState, expiryDate: date })}
                  />
                </div>
              </FormGroup>
            </Col>
            <Col lg="4">
              <FormGroup>
                <div className="common-react-select">
                  <p className="field-name">
                    {t('MANUAL_DOCUMENTS.TYPE')} <span className="asterisk">*</span>
                  </p>
                  <Select
                    placeholder="Select Type"
                    options={documentTypeList.filter((re) => re?.isActive)} // Replace with actual options
                    styles={customStyles}
                    className={`common-select ${errors.documentType ? 'is-invalid' : ''}`}
                    classNamePrefix="common-select"
                    getOptionLabel={({ name }) => `${name}`}
                    getOptionValue={({ _id }) => `${_id}`}
                    value={localState.documentType}
                    onChange={(selected) => setLocalStateData({ ...localState, documentType: selected })}
                  />
                  {errors.documentType && <div className="invalid-feedback d-block">{errors.documentType}</div>}
                </div>
              </FormGroup>
            </Col>
            <Col lg="4">
              <FormGroup>
                <div className="common-react-select">
                  <p className="field-name">{t('MANUAL_DOCUMENTS.BRAND')}</p>
                  <Select
                    placeholder="Select Brand"
                    options={brandList}
                    styles={customStyles}
                    className="common-select"
                    classNamePrefix="common-select"
                    getOptionLabel={({ name }) => `${name}`}
                    getOptionValue={({ _id }) => `${_id}`}
                    value={localState.selectedBrand}
                    onChange={(selected) => handleSelect(selected, 'selectedBrand')}
                  />
                </div>
              </FormGroup>
            </Col>
            {subBrandAccess && (
              <Col lg="4">
                <FormGroup>
                  <div className="common-react-select mb-0">
                    <p className="field-name">{t('POMS.GRADING_GROUP.TOP_GROUP_BAR.SUB_BRAND')}</p>
                    <Select
                      placeholder={t('DPP.BASIC_DETAILS.SELECT_SUB_BRAND')}
                      options={subBrandOptions?.filter((e) => e.isActive) || []}
                      styles={customStyles}
                      className="common-select"
                      classNamePrefix="common-select"
                      getOptionLabel={({ label }) => `${label}`}
                      getOptionValue={({ value }) => `${value}`}
                      value={localState.selectedSubBrand}
                      onChange={(selected) => handleSelect(selected, 'selectedSubBrand')}
                      isClearable
                    />
                  </div>
                </FormGroup>
              </Col>
            )}
            <Col lg="4">
              <FormGroup>
                <div className="common-react-select mb-0">
                  <p className="field-name">{t('DPP.BASIC_DETAILS.SUPPLIER')}</p>
                  <MultiSelect
                    options={supplierOptions}
                    className="product-custom-multiselect common-new-multiselect w-100"
                    value={localState?.selectedSupplier || []}
                    labelledBy={t('DPP.BASIC_DETAILS.SELECT_SUPPLIER')}
                    overrideStrings={{
                      selectSomeItems: t('DPP.BASIC_DETAILS.SELECT_SUPPLIER'),
                      search: t('DPP.BASIC_DETAILS.SEARCH_SUPPLIER'),
                    }}
                    ClearSelectedIcon={null}
                    onChange={(selected) => handleSelect(selected, 'selectedSupplier')}
                  />
                </div>
              </FormGroup>
            </Col>
          </Row>

          <div className="common-model-footer">
            <button aria-label="save" onClick={() => handleSubmit()} type="button" className="btn p-0" disabled={state?.loading}>
              <TickIcon size={28} />
            </button>
          </div>
        </>
      </Modal.Body>
    </Modal>
  );
}

export default UploadDocument;
